import React from "react";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
import { Modal, Button } from "antd";

const ClearModal = (props) => {
  /**
   * Clears all of the entered data
   */
  const handleClear = () => {
    props.clearCosts();
    props.clearBenefits();
    props.setShouldOpenClearModal(false);
  };

  return (
    <Modal
      title="Clear"
      visible={props.shouldOpenClearModal}
      onCancel={() => props.setShouldOpenClearModal(false)}
      footer={[
        <Button key="back" onClick={handleClear}>
          Clear
        </Button>,
        <Button key="back" onClick={() => props.setShouldOpenClearModal(false)}>
          Cancel
        </Button>,
      ]}
    >
      <p>This will clear all input data and is irreversible. Are you sure?</p>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    shouldOpenClearModal: state.status.shouldOpenClearModal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setShouldOpenClearModal: (v) => dispatch(actions.setShouldOpenClearModal(v)),
    clearCosts: () => dispatch(actions.clearCosts()),
    clearBenefits: () => dispatch(actions.clearBenefits()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClearModal);
